// UserPermission

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { USERPERMISSION } from "../../constants/api";
import { useNavigate } from "react-router-dom";
import { Edit, ShieldCheck } from "lucide-react";
import { Button } from "../../components/ui/button";
import { ContainerCard, ModuleTitleCard } from "../../components/ui/cards";
import { checkUserPermissionFunc } from "../../components/common/CommonFunctions";

const UserPermission = () => {

    const [UserPermissionData, setUserPermissionData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    let isSuperAdmin = JSON.parse(sessionStorage.getItem('is_super_admin'))
    
    let navigate = useNavigate()

    const { edit: editPermission } = checkUserPermissionFunc("administrator", "User Permission", "SubMenu") || {};

    const UserPermissionColumns = [
        {
            accessor: "usergroup_name",
            Header: "User Group",
            Cell: ({ value }) => value ?? "-",
        },
        ...(editPermission || isSuperAdmin ? [
            {
                accessor: "action",
                Header: "Action",
                sortable: false,
                Cell: ({ row }) => {
                    const handleOpenEdit = () => {
                        navigate("/admin/userpermission/add", { state: row })
                    };

                    return (
                        <div className="flex items-center gap-2">
                            {/* Edit Button */}
                            <Button
                                variant="ghost"
                                size="sm"
                                className="text-sidebar-primary hover:bg-blue-50 dark:hover:bg-gray-700"
                                onClick={handleOpenEdit}
                            >
                                <Edit className="h-4 w-4" />
                            </Button>
                        </div>
                    );
                },
            }
        ] : [])
    ];

    return (
        <ContainerCard>
            {/* Header */}
            <ModuleTitleCard Icon={ShieldCheck} title={'User Permission'} subtitle="Control system access through group-based permissions" />

            <Reactable
                columns={UserPermissionColumns}
                data={UserPermissionData}
                setData={setUserPermissionData}
                setTotalCount={setTotalRecords}
                url={USERPERMISSION}
                serverSide={true}
                tableHeight="calc(100vh - 320px)"
                rowSize={editPermission || isSuperAdmin ? "sm" : undefined}
                isCSVRequired={true}
                isPDFRequired={true}
            />
        </ContainerCard >
    );
}

export default UserPermission;